// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddThisButtonController from "./add_this_button_controller"
application.register("add-this-button", AddThisButtonController)

import CannedNotesController from "./canned_notes_controller"
application.register("canned-notes", CannedNotesController)

import CourseSelectController from "./course_select_controller"
application.register("course-select", CourseSelectController)

import CourseSelectValidatorController from "./course_select_validator_controller"
application.register("course-select-validator", CourseSelectValidatorController)

import DateChartController from "./date_chart_controller"
application.register("date-chart", DateChartController)

import DueDateChartController from "./due_date_chart_controller"
application.register("due-date-chart", DueDateChartController)

import ErrorToastController from "./error_toast_controller"
application.register("error-toast", ErrorToastController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import IaEaChartController from "./ia_ea_chart_controller"
application.register("ia-ea-chart", IaEaChartController)

import MaterialsBreakdownChartController from "./materials_breakdown_chart_controller"
application.register("materials-breakdown-chart", MaterialsBreakdownChartController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import ProgressChartController from "./progress_chart_controller"
application.register("progress-chart", ProgressChartController)

import RemoveConfirmController from "./remove_confirm_controller"
application.register("remove-confirm", RemoveConfirmController)

import SchoolFilterController from "./school_filter_controller"
application.register("school-filter", SchoolFilterController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SuccessToastController from "./success_toast_controller"
application.register("success-toast", SuccessToastController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import TableSorterController from "./table_sorter_controller"
application.register("table-sorter", TableSorterController)

import ToggleCheckboxesController from "./toggle_checkboxes_controller"
application.register("toggle-checkboxes", ToggleCheckboxesController)

import ToggleVisibilityController from "./toggle_visibility_controller"
application.register("toggle-visibility", ToggleVisibilityController)

import UrlMultiParamController from "./url_multi_param_controller"
application.register("url-multi-param", UrlMultiParamController)

import UrlParamController from "./url_param_controller"
application.register("url-param", UrlParamController)
